import React from 'react';
export function Hero() {
  return <section className="pt-[60px] pb-[50px] md:pt-[70px] md:pb-[60px] bg-gradient-to-b from-cream to-cream-dark relative overflow-hidden" data-id="element-163">
      {/* Background glow */}
      <div className="absolute -top-[150px] -right-[120px] w-[500px] h-[500px] bg-[radial-gradient(circle,rgba(184,137,75,0.18)_0%,transparent_70%)] rounded-full pointer-events-none" data-id="element-164" />

      <div className="container-wide" data-id="element-165">
        <div className="flex flex-col items-center text-center relative z-10 max-w-[720px] mx-auto" data-id="element-166">
          <div className="hero-animate-title" data-id="element-167">
            <h1 className="text-[clamp(38px,5.8vw,64px)] mb-5 leading-[1.05]" data-id="element-168">
              Dejá de trabajar{' '}
              <span className="text-gold-dark relative inline-block" data-id="element-169">
                el síntoma
              </span>
              . Entendé por fin{' '}
              <span className="text-gold-dark relative inline-block" data-id="element-170">
                el <span className="highlight-keyword" data-id="element-171">origen</span>
              </span>
              .
            </h1>

            <p className="font-serif text-[clamp(17px,2vw,20px)] text-gold-dark italic font-medium mb-8" data-id="element-172">
              El primer sistema en español que te enseña a trazar el{' '}
              <span className="highlight-keyword" data-id="element-173">origen</span>{' '}
              <span className="highlight-keyword" data-id="element-174">generacional</span> de tus{' '}
              <span className="highlight-keyword" data-id="element-175">patrones</span> — sola, en
              privado, con base científica.
            </p>
          </div>

          {/* Mockup image between subtitles */}
          <div className="w-full max-w-[680px] mx-auto mb-8 hero-animate-image" data-id="element-176">
            <div className="aspect-[16/9] rounded-[20px] shadow-deep relative overflow-hidden group" data-id="element-177">
              <img src="https://cdn.magicpatterns.com/uploads/hQf4kERnoM5F2rEnmd6KzR/mockup-mobile-600.webp" srcSet="https://cdn.magicpatterns.com/uploads/hQf4kERnoM5F2rEnmd6KzR/mockup-mobile-600.webp 600w, https://cdn.magicpatterns.com/uploads/bcWXDEHUdgqDiAW5xvh3T3/mockuup_(1).webp 1200w" sizes="(max-width: 768px) 100vw, 680px" alt="El Origen de Tus Bloqueos - Mockup del sistema" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" width={680} height={383} fetchPriority="high" loading="eager" decoding="async" data-id="element-178" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent pointer-events-none" data-id="element-179" />
              <div className="absolute bottom-5 right-5 bg-gold text-ink px-3.5 py-2 rounded-full text-[11px] font-semibold tracking-[0.08em] font-sans uppercase shadow-lg" data-id="element-180">
                ★ Sistema Completo
              </div>
            </div>
          </div>

          <div className="hero-animate-content" data-id="element-181">
            <p className="text-[17px] text-ink-soft mb-7 leading-relaxed" data-id="element-182">
              Si llevás años con terapia, libros y meditación, y el mismo{' '}
              <span className="highlight-keyword" data-id="element-183">patrón</span> vuelve a
              aparecer — no estás fallando. Estás trabajando el síntoma sin
              conocer la <span className="highlight-keyword" data-id="element-184">raíz</span>.
            </p>

            <div className="flex flex-wrap justify-center gap-2 mb-7" data-id="element-185">
              <span className="bg-white border border-border px-3.5 py-1.5 rounded-full text-[13px] text-ink font-medium" data-id="element-186">
                📘 100% Digital
              </span>
              <span className="bg-white border border-border px-3.5 py-1.5 rounded-full text-[13px] text-ink font-medium" data-id="element-187">
                ⚡ Acceso en 5 min
              </span>
              <span className="bg-white border border-border px-3.5 py-1.5 rounded-full text-[13px] text-ink font-medium" data-id="element-188">
                🔒 Privado · A tu ritmo
              </span>
              <span className="bg-white border border-border px-3.5 py-1.5 rounded-full text-[13px] text-ink font-medium" data-id="element-189">
                🧬 Con base científica
              </span>
            </div>

            <a href="#oferta" className="inline-flex items-center gap-2.5 bg-ink text-cream px-8 py-4 rounded-full no-underline text-base font-semibold shadow-deep transition-all duration-250 hover:bg-rust hover:-translate-y-0.5 group border-none cursor-pointer tracking-[0.01em]" data-id="element-190">
              Quiero entender el origen
              <span className="transition-transform duration-250 group-hover:translate-x-1" data-id="element-191">
                →
              </span>
            </a>

            <div className="flex flex-wrap justify-center gap-3.5 mt-4 text-[13px] text-ink-soft" data-id="element-192">
              <span className="inline-flex items-center gap-1.5" data-id="element-193">
                🛡️ Garantía 7 días
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-194">
                🔒 Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-195">
                💳 Mercado Pago
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}